var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavTaskManagerSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4716_16888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1.5C12.75 1.08579 12.4142 0.75 12 0.75C11.5858 0.75 11.25 1.08579 11.25 1.5V3.5C11.25 3.91421 11.5858 4.25 12 4.25C12.4142 4.25 12.75 3.91421 12.75 3.5V1.5Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75216 3.19151C4.45926 2.89862 3.98439 2.89862 3.6915 3.19151C3.3986 3.4844 3.3986 3.95928 3.6915 4.25217L5.10571 5.66638C5.3986 5.95928 5.87348 5.95928 6.16637 5.66638C6.45926 5.37349 6.45926 4.89862 6.16637 4.60572L4.75216 3.19151Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3085 4.25217C20.6014 3.95928 20.6014 3.4844 20.3085 3.19151C20.0156 2.89862 19.5407 2.89862 19.2478 3.19151L17.8336 4.60572C17.5407 4.89862 17.5407 5.37349 17.8336 5.66638C18.1265 5.95928 18.6014 5.95928 18.8943 5.66638L20.3085 4.25217Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 11.5C7.75 9.15279 9.65279 7.25 12 7.25C14.3472 7.25 16.25 9.15279 16.25 11.5C16.25 11.9142 16.5858 12.25 17 12.25C17.4142 12.25 17.75 11.9142 17.75 11.5C17.75 8.32436 15.1756 5.75 12 5.75C8.82436 5.75 6.25 8.32436 6.25 11.5C6.25 11.9142 6.58579 12.25 7 12.25C7.41421 12.25 7.75 11.9142 7.75 11.5Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10.75C1.58579 10.75 1.25 11.0858 1.25 11.5C1.25 11.9142 1.58579 12.25 2 12.25H4C4.41421 12.25 4.75 11.9142 4.75 11.5C4.75 11.0858 4.41421 10.75 4 10.75H2Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.75C19.5858 10.75 19.25 11.0858 19.25 11.5C19.25 11.9142 19.5858 12.25 20 12.25H22C22.4142 12.25 22.75 11.9142 22.75 11.5C22.75 11.0858 22.4142 10.75 22 10.75H20Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13.75C3.58579 13.75 3.25 14.0858 3.25 14.5C3.25 14.9142 3.58579 15.25 4 15.25H20C20.4142 15.25 20.75 14.9142 20.75 14.5C20.75 14.0858 20.4142 13.75 20 13.75H4Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17.75C6.58579 17.75 6.25 18.0858 6.25 18.5C6.25 18.9142 6.58579 19.25 7 19.25H17C17.4142 19.25 17.75 18.9142 17.75 18.5C17.75 18.0858 17.4142 17.75 17 17.75H7Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21.75C9.58579 21.75 9.25 22.0858 9.25 22.5C9.25 22.9142 9.58579 23.25 10 23.25H14C14.4142 23.25 14.75 22.9142 14.75 22.5C14.75 22.0858 14.4142 21.75 14 21.75H10Z",
    fill: "#ffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4716_16888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTaskManagerSelect);
export default __webpack_public_path__ + "static/media/navTaskManagerSelect.014c6ab387ba64669f492057d412a2bf.svg";
export { ForwardRef as ReactComponent };